module.exports = __webpack_public_path__ + "static/pivonuv-beh-2021-1ffe6ed8d12705baef4aefd559dda0b4.jpg";